import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { PolicyCommissionInvoiceListView } from '@components/Feature/PolicyCommissionInvoice';
import { PolicyCommissionInvoiceList } from '@models/PolicyCommissionInvoice';

import { routeUserDashboardPolicyCommissionInvoiceDetailsPage } from '../route';
import { selectPolicyCommissionInvoiceListPageReducer } from './selector';
import {
  policyCommissionInvoicesFetch,
  PolicyCommissionInvoicesFetchPayload,
} from './action';

const PolicyCommissionInvoiceListPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { invoices, pagination, isLoading } = useSelector(selectPolicyCommissionInvoiceListPageReducer);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const handleShow = (invoice: PolicyCommissionInvoiceList) => {
    navigate(routeUserDashboardPolicyCommissionInvoiceDetailsPage({ policyCommissionInvoiceId: invoice.id }));
  }

  useEffect(() => {
    const payload: PolicyCommissionInvoicesFetchPayload = { page, perPage };
    dispatch(policyCommissionInvoicesFetch(payload));
  }, [page, perPage]);

  return (
    <>
      <section>
        <h5 className="mb-4">Commission</h5>
        <Card className="mb-4">
          <Card.Body>
            <PolicyCommissionInvoiceListView
              invoices={invoices}
              pagination={pagination}
              isLoading={isLoading}
              onChangePage={setPage}
              onChangePerPage={setPerPage}
              onShow={handleShow}
            />
          </Card.Body>
        </Card>
      </section>
    </>
  );
};

export { PolicyCommissionInvoiceListPage };
